// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forms-method-payment-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.forms-method-payment-wrapper .vert-col {
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.forms-method-payment-wrapper .vert-row {
  display: flex;
  gap: var(--spacing-small);
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.forms-method-payment-wrapper .vert-row input {
  flex: 1;
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.forms-method-payment-wrapper .vert-row .vert-input:focus {
  border-color: var(--color-highlight-lighter) !important;
}
.forms-method-payment-wrapper .vert-row .vert-select {
  flex: 1.1;
}
.formMethodPayment .ant-form-item-control-input-content .vert-input.ant-input-affix-wrapper-disabled,
.formMethodPayment .ant-form-item-control-input-content .vert-input.ant-input-disabled {
  background-color: var(--bg-color-disabled-input) !important;
  border-color: var(--color-border) !important;
  color: var(--color-text-input-disabled) !important;
}
.formMethodPayment .ant-form-item-control-input-content #basic_numberCard[disabled] {
  background-color: var(--bg-color-disabled-input) !important;
  border-color: var(--color-border) !important;
  color: var(--color-text-input-disabled) !important;
}
.formMethodPayment .input-form-method-payment[disabled] {
  background-color: var(--bg-color-disabled-input) !important;
  border-color: var(--color-border) !important;
  color: var(--color-text-input-disabled) !important;
}
@media screen and (max-width: 768px) {
  .forms-method-payment-wrapper .vert-row {
    flex-direction: column;
  }
  .forms-method-payment-wrapper .vert-row input {
    min-height: 48px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Forms/FormsMethodPaymentStyles.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,2BAAA;EACA,0BAAA;AACF;AANA;EAQI,2BAAA;EACA,0BAAA;AACJ;AAVA;EAYI,aAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;AACJ;AAhBA;EAkBM,OAAA;EACA,0BAAA;EACA,yBAAA;AACN;AArBA;EAuBM,uDAAA;AACN;AAxBA;EA2BM,SAAA;AAAN;AAKA;;EAKI,2DAAA;EACA,4CAAA;EACA,kDAAA;AANJ;AAWK;EACE,2DAAA;EACA,4CAAA;EACA,kDAAA;AATP;AAcE;EACE,2DAAA;EACA,4CAAA;EACA,kDAAA;AAZJ;AAmBA;EACE;IAEI,sBAAA;EAlBJ;EAgBA;IAKM,gBAAA;EAlBN;AACF","sourcesContent":[".forms-method-payment-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-small);\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n\n  .vert-col {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .vert-row {\n    display: flex;\n    gap: var(--spacing-small);\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n\n    input {\n      flex: 1;\n      margin-right: 0 !important;\n      margin-left: 0 !important;\n    }\n    .vert-input:focus {\n      border-color: var(--color-highlight-lighter) !important;\n    }\n\n    .vert-select {\n      flex: 1.1;\n    }\n  }\n}\n\n.formMethodPayment{\n\n .ant-form-item-control-input-content{\n\n  .vert-input.ant-input-affix-wrapper-disabled, .vert-input.ant-input-disabled {\n    background-color: var(--bg-color-disabled-input) !important;\n    border-color: var(--color-border) !important;\n    color: var(--color-text-input-disabled) !important;\n  }\n\n\n   #basic_numberCard{\n     &[disabled] {\n       background-color: var(--bg-color-disabled-input) !important;\n       border-color: var(--color-border) !important;\n       color: var(--color-text-input-disabled) !important;\n      }\n    }\n}\n.input-form-method-payment {\n  &[disabled] {\n    background-color: var(--bg-color-disabled-input) !important;\n    border-color: var(--color-border) !important;\n    color: var(--color-text-input-disabled) !important;\n  }\n}\n}\n\n\n\n@media screen and (max-width: 768px) {\n  .forms-method-payment-wrapper {\n    .vert-row {\n      flex-direction: column;\n\n      input {\n        min-height: 48px;\n      }\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
